<form #form="ngForm" class="form" novalidate>
    <div class="row container-sem-contato" *ngIf="!entity">
        <div class="col-12">
            <div class="alert alert-info alert-sem-contato text-center" role="alert">
                <i class="fas fa-map-marker-alt alert-icon" aria-hidden="true"></i>
                <h4>
                    Contato 
                    <span *ngIf="isContatoPrincipal()"> Principal </span>
                    <span *ngIf="isContatoCobranca()"> de Cobrança </span>
                    <span *ngIf="isContatoEntrega()"> de Entrega </span>
                    não adicionado
                </h4>
    
                <button *ngIf="canInsert()" type="button" class="btn btn-primary btn-add" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Contato
                </button>        
            </div>
        </div>
    </div>

    <div class="row" *ngIf="entity">
        <div class="col-12">
            <div class="row" *ngIf="canDelete()">
                <div class="col-12 text-right">
                    <button type="button" class="btn btn-light" (click)="deleteClick()">
                        <i class="far fa-trash-alt" aria-hidden="true"></i> Excluir
                    </button>
                </div>
            </div>
            
            <div class="row">
                <div class="form-group col-12">
                        <label for="contatoNome_{{tipoContato}}" class="col-form-label">Nome</label>
                        <input type="text" class="form-control" [(ngModel)]="entity.nome" name="contatoNome_{{tipoContato}}" id="contatoNome_{{tipoContato}}"
                        #contatoNome="ngModel" maxlength="255" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    <!-- <sgt-form-control-error
                        *ngIf="contatoNome.errors && contatoNome.errors.required && contatoNome.dirty"
                        msgError="O nome é obrigatório">
                    </sgt-form-control-error> -->
                    <sgt-form-control-error
                        *ngIf="contatoNome.errors && contatoNome.errors.maxlength"
                        msgError="O nome deve ter no máximo 255 caracteres">
                    </sgt-form-control-error>                    
                </div>
            </div>
            <div class="row">
                <div class="form-group col-12 col-md-3">
                    <label for="contatoFone_{{tipoContato}}" class="col-form-label">Telefone</label>
                    <input type="tel" class="form-control" [(ngModel)]="entity.fone" name="contatoFone_{{tipoContato}}" id="contatoFone_{{tipoContato}}"
                        #contatoFone="ngModel" [ngControl]="contatoFone" sgtFone [required]="telefoneRequired"
                        [disabled]="!canEdit" [readonly]="!canEdit"
                        [isValidate]="!exterior" [isApplyMask]="!exterior">
                    <p style="margin-bottom:0px;" class="form-text text-muted">Caso o cliente possua somente celular, informe aqui também o celular.</p>
                    <sgt-form-control-error
                        *ngIf="contatoFone.errors && contatoFone.errors.required && contatoFone.dirty"
                        msgError="O telefone é obrigatório">
                    </sgt-form-control-error>                        
                    <sgt-form-control-error
                        *ngIf="contatoFone.errors && contatoFone.errors.foneInvalido"
                        msgError="O telefone deve ter no míninio 10 dígitos com o DDD">
                    </sgt-form-control-error>                                                          
                </div>
                <div class="form-group col-12 col-md-3">
                    <label for="contatoCelular_{{tipoContato}}" class="col-form-label">Celular</label>
                    <input type="tel" class="form-control" [(ngModel)]="entity.celular" name="contatoCelular_{{tipoContato}}" id="contatoCelular_{{tipoContato}}"
                        #contatoCelular="ngModel" [ngControl]="contatoCelular" sgtFone
                        [disabled]="!canEdit" [readonly]="!canEdit" [required]="celularRequired"
                        [isValidate]="!exterior" [isApplyMask]="!exterior">
                    <sgt-form-control-error
                        *ngIf="contatoCelular.errors && contatoCelular.errors.required && contatoCelular.dirty"
                        msgError="O celular é obrigatório">
                    </sgt-form-control-error>                        
                    <sgt-form-control-error
                        *ngIf="contatoCelular.errors && contatoCelular.errors.foneInvalido"
                        msgError="O celular deve ter no míninio 10 dígitos com o DDD">
                    </sgt-form-control-error>                                              
                </div>  
                <div class="form-group col-12 col-md-6">
                    <label for="contatoEmail_{{tipoContato}}" class="col-form-label">E-mail</label>
                    <input type="email" class="form-control" [(ngModel)]="entity.email" name="contatoEmail_{{tipoContato}}" id="contatoEmail_{{tipoContato}}"
                        #contatoEmail="ngModel" maxlength="100" sgtLowercase
                        [disabled]="!canEdit" [readonly]="!canEdit" [required]="emailRequired">
                    <sgt-form-control-error
                        *ngIf="contatoEmail.errors && contatoEmail.errors.required && contatoEmail.dirty"
                        msgError="O e-mail é obrigatório">
                    </sgt-form-control-error>                        
                    <sgt-form-control-error
                        *ngIf="contatoEmail.errors && contatoEmail.errors.maxlength"
                        msgError="O e-mail deve ter no máximo 100 caracteres">
                    </sgt-form-control-error>                                       
                </div>                                
            </div>
            <div class="row">
                <div class="form-group col-12">
                    <label for="contatoAnotacao_{{tipoContato}}" class="col-form-label">Anotação do Contato</label>
                    <textarea class="form-control" [(ngModel)]="entity.anotacao" name="contatoAnotacao_{{tipoContato}}" id="contatoAnotacao_{{tipoContato}}"
                        #contatoAnotacao="ngModel" maxlength="500" rows="5" sgtUppercase
                        [disabled]="!canEdit" [readonly]="!canEdit">
                    </textarea>
                    <sgt-form-control-error
                        *ngIf="contatoAnotacao.errors && contatoAnotacao.errors.maxlength"
                        msgError="A anotação deve ter no máximo 500 caracteres">
                    </sgt-form-control-error>                           
                </div>
            </div>                  
        </div>
    </div>
</form>
    